const apiUrls = {
  getAnnouncements: "/api/announcements/getannouncements/",
  quizValidation: "/api/quiz/validate-code/",
  getUserBillingDetails: "/api/pricing/user-billing-details",
  checkoutSession: "/api/checkout/session",
  getAppSettings: "/api/appsettings/info"
};

export default apiUrls;
